"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _stream = _interopRequireDefault(require("stream"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class StreamReader extends _stream.default.Writable {
  constructor(readable) {
    super();
    this.buffers = [];
    this.finished = false;
    this.error = null;
    readable.pipe(this);
    this.on('error', this.handleError.bind(this));
  }

  write(chunk, encoding, callback) {
    if (typeof encoding === 'function') {
      callback = encoding;
    }

    this.buffers.push(chunk);

    if (callback) {
      callback();
    }
  }

  end(chunk, encoding, callback) {
    if (typeof encoding === 'function') {
      callback = encoding;
    }

    if (chunk) {
      this.buffers.push(chunk);
    }

    this.finished = true;
    this.emit('finish');

    if (callback) {
      callback();
    }
  }

  handleError(error) {
    this.error = error;
  }

  readAll() {
    const _this = this;

    const promise = new Promise(function (resolve, reject) {
      function cleanup() {
        _this.removeListener('finish', handleFinished);

        _this.removeListener('error', handleError);
      }

      function handleError(error) {
        _this.error = error;
        reject(error);
        cleanup();
      }

      function handleFinished() {
        resolve(Buffer.concat(_this.buffers));
        cleanup();
      }

      _this.once('finish', handleFinished);

      _this.once('error', handleError);
    });
    return promise;
  }

}

exports.default = StreamReader;
module.exports = exports.default;
//# sourceMappingURL=StreamReader.js.map